import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toDayDate } from '../../common/formatDateText';
import { ContainerFull } from '../../components/ContainerFull';
import { capitalizarPalabras, firstCapitalLetter } from '../../common/upperCaseWord';

import {
	BriefcaseIcon,
	CalendarIcon,
	MapPinIcon,
	SquaresPlusIcon,
} from '@heroicons/react/20/solid'
import { optionsAllCourseListOpenByIdUser } from '../../redux/actions/options';
import { SkeletonPost } from './skeletons/SkeletonPost';
import { PostCard } from './components/post/PostCard';
import { Tooltip, Zoom } from '@mui/material';
import { ModalAddPost } from './components/post/ModalAddPost';
import { getUserPosts } from '../../redux/actions/home';
import { SliderDayPayment } from './components/SliderDayPayment';
import { getSyncUserData } from '../../redux/actions/user';
import { ListCoursesCarousel } from './components/listCoursesCarousel/ListCoursesCarousel';

export const HomePage = () => {
	const dispatch = useDispatch();
	const { posts, loading: loadingPost } = useSelector((state) => state.home);
	const { user } = useSelector((state) => state.user)
	const { _id: userId, firstName, lastName, typeUser, location } = user;
	const [openAddPostModal, setOpenAddPostModal] = useState(false);
	const canViewCreatePost = ["director", "administrativo"];
	const canViewCardCourse = ["estudiante", "profesor"];
	const canViewSubscription = typeUser === "estudiante";


	useEffect(() => {
		dispatch(getSyncUserData(userId));
		dispatch(optionsAllCourseListOpenByIdUser(userId));
		dispatch(getUserPosts(userId));
	}, [dispatch]);

	return (
		<ContainerFull>
			<div className="w-full px-2">
				<div className="lg:flex lg:items-center lg:justify-between">
					<div className="flex-1">
						<h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
							{`Bienvenido ${firstCapitalLetter(firstName)} ${firstCapitalLetter(lastName)}`}
						</h2>
						<div className="mt-1 hidden lg:flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
							<div className="mt-2 flex items-center text-sm text-gray-500">
								<BriefcaseIcon className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
								{firstCapitalLetter(typeUser)}
							</div>
							<div className="mt-2 flex items-center text-sm text-gray-500">
								<MapPinIcon className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
								{capitalizarPalabras(location)}
							</div>
							<div className="mt-2 flex items-center text-sm text-gray-500">
								<CalendarIcon className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
								{capitalizarPalabras(toDayDate())}
							</div>
						</div>
					</div>
				</div>
			</div>
			{
				canViewCreatePost.includes(typeUser) && (
					<div className='w-full flex justify-end gap-4'>
						{
							canViewCreatePost.includes(typeUser) && (
								<Tooltip title="Agregar un nuevo post" TransitionComponent={Zoom} placement='top'>
									<button
										type='button'
										onClick={() => setOpenAddPostModal(true)}
										className='w-full md:w-auto flex flex-row justify-center items-center gap-2 rounded-md px-4 py-2 font-semibold text-md text-white bg-indigo-600 hover:bg-indigo-800'
									>
										<SquaresPlusIcon className="block h-5 w-5" aria-hidden="true" />
										<p>Agregar nuevo post</p>
									</button>
								</Tooltip>
							)
						}
					</div>
				)
			}
			<div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
				<div className={`order-2 lg:order-none ${canViewCardCourse.includes(typeUser) ? `lg:col-span-8` : `lg:col-span-12`}`}>
					<div className="flex flex-col">
						{loadingPost ? (
							<SkeletonPost />
						) : (
							<div className='w-full'>
								{posts?.length > 0 ? (
									posts.map(({ _id, title, createdBy, releaseDate, expirationDate, urlName, message, link }) => (
										<PostCard
											key={_id}
											id={_id}
											userId={userId}
											title={title}
											author={`${createdBy?.firstName} ${createdBy?.secondName} ${createdBy?.lastName} ${createdBy?.secondSurname}`}
											releaseDate={releaseDate}
											expirationDate={expirationDate}
											urlImg={urlName}
											message={message}
											url={link}
											typeUser={typeUser}
										/>
									))
								) : (
									<div className='flex w-full justify-center items-center bg-white p-4 rounded-md mt-4 shadow-md'>
										<p className='text-gray-400'>No hay publicaciones.</p>
									</div>
								)}
								<div className='flex w-full h-[50px]'></div>
							</div>
						)}
					</div>
				</div>
				{
					canViewCardCourse.includes(typeUser) && (
						<div className="order-1 lg:order-none lg:col-span-4">
							{canViewSubscription && (
								<div className='flex w-full justify-center items-center bg-white p-4 rounded-md mt-4 shadow-md'>
									<SliderDayPayment />
								</div>
							)}

							<div className="hidden lg:block lg:col-span-2">
								<ListCoursesCarousel />
							</div>
						</div>
					)
				}
			</div>

			<ModalAddPost
				open={openAddPostModal}
				setOpen={setOpenAddPostModal}
			/>
		</ContainerFull>
	)
}
